import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { FiCheck, FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Input, Button, Card } from "../components/ui";
import { changePassword } from "../api/users";
import { useToast } from "../context/ToastContext";
import logo from "../Assets/Images/EMPACT LOGO.png";

export default function ForceChangePassword() {
  const navigate = useNavigate();
  const { notify } = useToast();
  const { updateUser } = useContext(AuthContext);

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const validate = () => {
    const next = {};

    if (!form.currentPassword) {
      next.currentPassword = "Enter your temporary password.";
    }

    if (!form.newPassword) {
      next.newPassword = "Enter a new password.";
    } else if (form.newPassword.length < 8) {
      next.newPassword = "Must be at least 8 characters.";
    }

    if (
      form.newPassword &&
      form.newPassword === form.currentPassword
    ) {
      next.newPassword =
        "New password must be different from your temporary password.";
    }

    if (form.confirmPassword !== form.newPassword) {
      next.confirmPassword = "Passwords don't match.";
    }

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setSaving(true);

    try {
      await changePassword(
        form.currentPassword,
        form.newPassword
      );

      updateUser({ mustChangePassword: false });
      
      notify("Your password has been updated.", "success");

      navigate("/dashboard", { replace: true });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Couldn't update your password. Please try again.";

      if (message.toLowerCase().includes("current password")) {
        setErrors((prev) => ({
          ...prev,
          currentPassword: message,
        }));
      } else {
        notify(message, "error");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <img
            src={logo}
            alt="Empact Alumni"
            className="h-9 w-auto"
          />
        </div>

        <Card className="p-6">
          <div className="mb-6 text-center">
            <h1 className="text-xl font-bold text-slate-900">
              Set your new password
            </h1>

            <p className="mt-2 text-sm text-slate-500">
              Your account was created with a temporary password.
              Please choose a new password before continuing.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Temporary password"
              type="password"
              icon={<FiLock className="h-4 w-4" />}
              value={form.currentPassword}
              onChange={(e) =>
                setForm({
                  ...form,
                  currentPassword: e.target.value,
                })
              }
              error={errors.currentPassword}
              required
            />

            <Input
              label="New password"
              type="password"
              icon={<FiLock className="h-4 w-4" />}
              value={form.newPassword}
              onChange={(e) =>
                setForm({
                  ...form,
                  newPassword: e.target.value,
                })
              }
              error={errors.newPassword}
              hint="At least 8 characters."
              required
            />

            <Input
              label="Confirm new password"
              type="password"
              icon={<FiLock className="h-4 w-4" />}
              value={form.confirmPassword}
              onChange={(e) =>
                setForm({
                  ...form,
                  confirmPassword: e.target.value,
                })
              }
              error={errors.confirmPassword}
              required
            />

            <Button
              type="submit"
              loading={saving}
              className="w-full justify-center"
              size="lg"
            >
              <FiCheck className="h-4 w-4" />
              Set new password
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}